import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


!function(e){var n=!1;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var o=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=o,t}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}return function n(o){function t(n,r,i){var c;if("undefined"!=typeof document){if(arguments.length>1){if("number"==typeof(i=e({path:"/"},t.defaults,i)).expires){var a=new Date;a.setMilliseconds(a.getMilliseconds()+864e5*i.expires),i.expires=a}i.expires=i.expires?i.expires.toUTCString():"";try{c=JSON.stringify(r),/^[\{\[]/.test(c)&&(r=c)}catch(e){}r=o.write?o.write(r,n):encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=(n=(n=encodeURIComponent(String(n))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape);var s="";for(var f in i)i[f]&&(s+="; "+f,!0!==i[f]&&(s+="="+i[f]));return document.cookie=n+"="+r+s}n||(c={});for(var p=document.cookie?document.cookie.split("; "):[],d=/(%[0-9A-Z]{2})+/g,u=0;u<p.length;u++){var l=p[u].split("="),C=l.slice(1).join("=");this.json||'"'!==C.charAt(0)||(C=C.slice(1,-1));try{var g=l[0].replace(d,decodeURIComponent);if(C=o.read?o.read(C,g):o(C,g)||C.replace(d,decodeURIComponent),this.json)try{C=JSON.parse(C)}catch(e){}if(n===g){c=C;break}n||(c[g]=C)}catch(e){}}return c}}return t.set=t,t.get=function(e){return t.call(t,e)},t.getJSON=function(){return t.apply({json:!0},[].slice.call(arguments))},t.defaults={},t.remove=function(n,o){t(n,"",e(o,{expires:-1}))},t.withConverter=n,t}(function(){})});


jQuery(document).ready(function( $ ) {


    function equalizeSite() {
        if (!accessibleFont) {
            // Found an issue with this script when a browser is zooming in/out so we disable it on zoom.
            //		var zoom = detectZoom.zoom();
            //		if(zoom != 1) return;

            // Break Points: These are what you have setup in the _settings.scss
            // The actual points where it converts from mobile to tablet and tablet to desktop.
            // Sometimes there is not a tablet design in this case simply set it to the same as the desktop.
            var $bptablet = 768,
                $bpdesktop = 1200;

            // Designed Sizes: These sizes are referencing what you are using to design the site e.g. PSD, AI etc.
            // This is what you have your media queries set to. Remember you only need 1 set of styles for each device this
            // script will handle the rest.
            var $mobile = 730,
                $tablet = 1000,
                $desktop = 1400;

            // Initial Font Size: This is based on what the common copy font size is for each design.
            var $fsmobile = 16,
                $fstablet = 16,
                $fsdesktop = 16;

            var $ww = window.innerWidth;

            var $fontsize = 16;

            if ($ww < $bptablet) {
                // mobile
                $fontsize = $fsmobile * ($ww / $mobile);
            } else if ($ww < $bpdesktop) {
                // tablet
                $fontsize = $fstablet * ($ww / $tablet);
            } else if ($ww <= 1400) {
                // desktop
                $fontsize = $fsdesktop * ($ww / $desktop);
            } else {
                $fontsize = 18;
            }

            var fontsize = Cookies.get('fontsize');

            if (typeof fontsize !== 'undefined') {
                $fontsize = parseInt($fontsize) + parseInt(fontsize);
            }

            $('html').css('font-size', $fontsize);


            defaultSize = $fontsize;
        }
    }

    equalizeSite();

    $(document).foundation();



    if (Cookies.get('contrast') != 1) {
        if (Cookies.get('contrast') == 'high') {
            $('body').addClass('high-contrast');
        }
        if (Cookies.get('contrast') == 'low') {
            $('body').addClass('low-contrast');
        }
    }


    var defaultSize = 16,
        accessibleFont = false;


    $('a.accessibility').click(function (e) {
        e.preventDefault();
    });

    $('.smaller-font').click(function (e) {
        e.preventDefault();

        var fontsize = Cookies.get('fontsize');

        if (typeof fontsize === 'undefined') {
            fontsize = 0;
        }

        fontsize--;

        Cookies.set('fontsize', fontsize);
        equalizeSite();
    });

    $('.larger-font').click(function (e) {
        e.preventDefault();

        var fontsize = Cookies.get('fontsize');

        if (typeof fontsize === 'undefined') {
            fontsize = 0;
        }

        fontsize++;

        Cookies.set('fontsize', fontsize);
        equalizeSite();
    });

    $('.reset-font').click(function (e) {
        e.preventDefault();

        Cookies.set('fontsize', 0);
        equalizeSite();
    });


    $(window).resize(function () {
        equalizeSite();
    });


    equalizeSite();


    $('.high-contrast-btn').click(function (e) {
        e.preventDefault();
        $('body').removeClass('low-contrast');
        $('body').addClass('high-contrast');
        Cookies.set('contrast', 'high');
    });

    $('.low-contrast-btn').click(function (e) {
        e.preventDefault();
        $('body').removeClass('high-contrast');
        $('body').addClass('low-contrast');
        Cookies.set('contrast', 'low');

    });

    $('.reset-contrast-btn').click(function (e) {
        e.preventDefault();
        $('body').removeClass('low-contrast');
        $('body').removeClass('high-contrast');
        Cookies.set('contrast', 0);
    });

    $('.menu-button').click(function (e) {
        e.preventDefault();
        $('body').toggleClass('expanded');
    });


    $('button[data-accordion-id]').click(function () {
        var accordion_id = $(this).data('accordion-id');
        if (jQuery('#accordion' + accordion_id).hasClass('all-expanded')) {
            jQuery('#accordion' + accordion_id).parent('.page-accordion').find('.expand-all button').text('Expand All');
            jQuery('#accordion' + accordion_id).removeClass('all-expanded');
            jQuery('#accordion' + accordion_id).each(function () {
                var $acc = jQuery(this);
                var $openSections = $acc.find('.accordion-item .accordion-content');
                $openSections.each(function (i, section) {
                    $acc.foundation('up', $(section));
                });
            });
        } else {
            jQuery('#accordion' + accordion_id).addClass('all-expanded');
            jQuery('#accordion' + accordion_id).parent('.page-accordion').find('.expand-all button').text('Collapse All');
            jQuery('#accordion' + accordion_id).each(function () {
                var $acc = jQuery(this);
                var $openSections = $acc.find('.accordion-item .accordion-content');
                $openSections.each(function (i, section) {
                    $acc.foundation('down', $(section));
                });
            });
        }
    });

});